let html = `<div class="torrent-file selector">
    <div class="torrent-file__title">{title}<span class="exe">.{exe}</span></div>
    <div class="torrent-file__size">{size}</div>
</div>`

export default html